import React from 'react';
import { observer } from 'mobx-react';
import { action, extendObservable } from 'mobx';
import { TASK_ALL, TASK_MINE } from '../../../helpers/constants';
import store from '../../../stores/store';
import TitleInputBox from '../../_shared/Fields/TitleSearchInput';
import CategoryInputBox from '../../_shared/Fields/CategorySearchInput';
import OwnerInputBox from '../../_shared/Fields/OwnerSearchInput';
import TaskPlaceholder from './TaskPlaceholder';
import './Tasks.css';
import TaskCard from './TaskCard';
import ErrorBoundary from '../../_shared/ErrorBoundary';
import filterIcon from '../../../assets/images/filter-icon.svg';
import activeFilterIcon from '../../../assets/images/active-filter-icon.svg';
import sortIconUp from '../../../assets/images/sort-icon-up.svg';
import sortIconDown from '../../../assets/images/sort-icon-down.svg';
import calendarIcon from '../../../assets/images/calendar.svg';
import {
    TASK_NOT_COMMENCED_TXT,
    TASK_IN_PROGRESS_TXT,
    TASK_COMPLETE_TXT,
    TASK_ARCHIVED_TXT,
} from '../../../helpers/constants';

import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'moment/locale/en-au';
import 'react-datepicker/dist/react-datepicker.css';

const TaskPanel = observer(
    class TaskPanel extends React.Component {
        //#region CONSTRUCTOR
        constructor() {
            super();

            this.clickDocument = this.clickDocument.bind(this);

            this.state = {
                filter: TASK_ALL,
            };

            this.vars = extendObservable(this, {
                currentOrderIcon: sortIconUp,

                //filter icons
                titleFilterIcon: true,
                categoryFilterIcon: false,
                dueDateFilterIcon: false,
                ownerFilterIcon: false,
                statusFilterIcon: false,

                // search boxes
                titleSearchBox: false,
                categorySearchBox: false,
                dueDateSearchBox: false,
                ownerSearchBox: false,
                statusSearchBox: false,

                // status check boxes
                statusNotCommenced: false,
                statusInProgress: false,
                statusComplete: false,
                statusArchived: false,

                set: action((field, value) => {
                    this[field] = value;
                })
            });
        }
        //#endregion

        //#region GET METHODS

        clickDocument(e) {
            var clickedOutside = true
            if (e.target.tagName === 'LI'
                && e.target.parentElement !== undefined
                && e.target.parentElement.className !== undefined
                && e.target.parentElement.className.indexOf('task-dropdown-menu') > -1) {
                clickedOutside = false
            }

            if (e.target.tagName === 'SPAN'
                && e.target.className !== undefined
                && e.target.className.indexOf('status-text') > -1) {
                clickedOutside = false
            }

            if ((e.target !== undefined
                && e.target.name !== undefined
                && (e.target.name.indexOf('task-start-date') > -1 ||
                    e.target.name.indexOf('task-end-date') > -1)) ||
                (e.target.className !== undefined
                    && e.target.className.indexOf('react-datepicker') > -1)) {
                clickedOutside = false
            }

            if (clickedOutside && (e.target.name === undefined || e.target.name.indexOf('filter') === -1)) {
                if (this.checkIfAnySearchBoxIsVisible()) {
                    this.setAllFilterBoxesHidden();
                }
            }
        }

        //#endregion

        //#region SET METHODS
        setFilter = filter => {
            this.setState({ filter: filter });
        };

        onChangeStatus = async (instanceId, groupId, taskId, statusId) => {
            await store.tasks.editTaskStatus(instanceId, taskId, statusId);
            store.tasks.setLocalDataTaskStatus(instanceId, groupId, taskId, statusId);
        };

        //#endregion

        //#region BUILD-IN METHODS
        componentDidMount() {
            document.addEventListener('mousedown', this.clickDocument);
            document.addEventListener('ontouchstart', this.clickDocument);
            // document.addEventListener('ontouchend', this.clickDocument);
            moment().locale('en-AU');
        }

        componentWillUnmount() {
            document.removeEventListener('mousedown', this.clickDocument);
            document.removeEventListener('ontouchstart', this.clickDocument);
            // document.addEventListener('ontouchend', this.clickDocument);
        }

        componentDidUpdate() {
            if (store.tasks.isExistMyTask()) {
                store.tasks.setShowMyTasksTab(true);
            } else {
                if (this.state.filter === TASK_MINE) {
                    this.setFilter(TASK_ALL);
                }
                store.tasks.setShowMyTasksTab(false);
            }
        }
        //#endregion

        //#region ORDERING

        onClickTableHeaderColumn(columnNum) {
            if (store.tasks.currentFilterSelection === columnNum) {
                if (store.tasks.currentColumnOrder === 'asc') {
                    store.tasks.currentColumnOrder = 'desc'
                    this.vars.set('currentOrderIcon', sortIconDown)
                }
                else {
                    store.tasks.currentColumnOrder = 'asc'
                    this.vars.set('currentOrderIcon', sortIconUp)
                }
            }
            else {
                this.setAllColumnsToFalse();
                store.tasks.currentFilterSelection = columnNum
                store.tasks.currentColumnOrder = 'asc'
                this.vars.set('currentOrderIcon', sortIconUp)
                switch (columnNum) {
                    case 1:
                        this.vars.set('categoryFilterIcon', true)
                        break;
                    case 2:
                        this.vars.set('dueDateFilterIcon', true)
                        break;
                    case 3:
                        this.vars.set('ownerFilterIcon', true)
                        break;
                    case 4:
                        this.vars.set('statusFilterIcon', true)
                        break;
                    default:
                        this.vars.set('titleFilterIcon', true)
                        break;
                }
            }

            this.orderData();
        }

        onClickFilter(columnNum) {
            if (this.checkIfAnySearchBoxIsVisible()) {
                this.setAllFilterBoxesHidden();
                return 
            }
            switch (columnNum) {
                case 1:
                    this.vars.set('categorySearchBox', !this.vars.categorySearchBox)
                    break;
                case 2:
                    this.vars.set('dueDateSearchBox', !this.vars.dueDateSearchBox)
                    break;
                case 3:
                    this.vars.set('ownerSearchBox', !this.vars.ownerSearchBox)
                    break;
                case 4:
                    this.vars.set('statusSearchBox', !this.vars.statusSearchBox)
                    break;
                default:
                    this.vars.set('titleSearchBox', !this.vars.titleSearchBox)
                    break;
            }
        }

        cleanSearchBox(columnNum) {
            switch (columnNum) {
                case 1:
                    store.tasks.set('categorySearchText', "")
                    break;
                case 2:
                    store.tasks.set('dueStartDate', null)
                    store.tasks.set('dueEndDate', null)
                    store.tasks.set('noDueDate', false)
                    this.onClickFilter(2)
                    break;
                case 3:
                    store.tasks.set('ownerSearchText', "")
                    break;
                case 4:
                    store.tasks.set('statusSearchText', "")
                    this.setAllStatusCheckBoxesFalse()
                    break;
                default:
                    store.tasks.set('titleSearchText', "")
                    break;
            }

            this.filterData()
        }

        orderData() {
            store.tasks.orderDataFilteredByHierarchy()
        }

        filterData() {
            store.tasks.searchTasks()
        }

        setAllColumnsToFalse() {
            this.vars.set('titleFilterIcon', false)
            this.vars.set('categoryFilterIcon', false)
            this.vars.set('dueDateFilterIcon', false)
            this.vars.set('ownerFilterIcon', false)
            this.vars.set('statusFilterIcon', false)
        }

        setAllFilterBoxesHidden = () => {
            this.vars.set('titleSearchBox', false)
            this.vars.set('categorySearchBox', false)
            this.vars.set('dueDateSearchBox', false)
            this.vars.set('ownerSearchBox', false)
            this.vars.set('statusSearchBox', false)
        }

        setAllStatusCheckBoxesFalse = () => {
            this.vars.set('statusNotCommenced', false)
            this.vars.set('statusInProgress', false)
            this.vars.set('statusComplete', false)
            this.vars.set('statusArchived', false)
        }

        checkIfAnySearchBoxIsVisible = () => {
            if (this.vars.titleSearchBox
                || this.vars.categorySearchBox
                || this.vars.dueDateSearchBox
                || this.vars.ownerSearchBox
                || this.vars.statusSearchBox) {
                return true;
            }

            return false;
        }

        onChange = e => {
            if (e.target.name === "title-task-filter") {
                store.tasks.set('titleSearchText', e.target.value)
            }
            else if (e.target.name === "category-task-filter") {
                store.tasks.set('categorySearchText', e.target.value)
            }
            else if (e.target.name === "owner-task-filter") {
                store.tasks.set('ownerSearchText', e.target.value)
            }
            else if (e.target.name === "task-filter-ch1") {
                this.vars.set('statusNotCommenced', !this.vars.statusNotCommenced)
                this.setStatusSearchText()
            }
            else if (e.target.name === "task-filter-ch2") {
                this.vars.set('statusInProgress', !this.vars.statusInProgress)
                this.setStatusSearchText()
            }
            else if (e.target.name === "task-filter-ch3") {
                this.vars.set('statusComplete', !this.vars.statusComplete)
                this.setStatusSearchText()
            }
            else if (e.target.name === "task-filter-ch4") {
                this.vars.set('statusArchived', !this.vars.statusArchived)
                this.setStatusSearchText()
            }
            else if (e.target.className.indexOf("category-name") > -1) {
                store.tasks.set('categorySearchText', e.target.innerHTML)
            }
            else if (e.target.className.indexOf("owner-name") > -1 || e.srcElement.className.indexOf("owner-name")) {
                store.tasks.set('ownerSearchText', e.target.innerHTML)
            }

            this.filterData()
        }

        handleChangeStart = date => {
            store.tasks.set('dueStartDate', date)
            store.tasks.set('noDueDate', false)
            this.filterData()
        }

        handleChangeEnd = date => {
            store.tasks.set('dueEndDate', date)
            store.tasks.set('noDueDate', false)
            this.filterData()

            if (store.tasks.dueStartDate && store.tasks.dueEndDate) {
                this.vars.set('dueDateSearchBox', false)
            }
        }

        getAllNoDueDateTasks = () => {
            store.tasks.set('dueStartDate', null)
            store.tasks.set('dueEndDate', null)
            store.tasks.set('noDueDate', !store.tasks.noDueDate)
            this.filterData()
            this.onClickFilter(2)
        }

        cleanAllFilters = () => {
            store.tasks.clearAllFilters()
            this.setAllStatusCheckBoxesFalse()
            this.filterData()
        }

        setStatusSearchText() {
            var tempStatusText = ""
            if (this.vars.statusNotCommenced) {
                if (tempStatusText === "") {
                    tempStatusText = TASK_NOT_COMMENCED_TXT
                }
                else {
                    tempStatusText = tempStatusText + "," + TASK_NOT_COMMENCED_TXT
                }
            }

            if (this.vars.statusInProgress) {
                if (tempStatusText === "") {
                    tempStatusText = TASK_IN_PROGRESS_TXT
                }
                else {
                    tempStatusText = tempStatusText + "," + TASK_IN_PROGRESS_TXT
                }
            }

            if (this.vars.statusComplete) {
                if (tempStatusText === "") {
                    tempStatusText = TASK_COMPLETE_TXT
                }
                else {
                    tempStatusText = tempStatusText + "," + TASK_COMPLETE_TXT
                }
            }

            if (this.vars.statusArchived) {
                if (tempStatusText === "") {
                    tempStatusText = TASK_ARCHIVED_TXT
                }
                else {
                    tempStatusText = tempStatusText + "," + TASK_ARCHIVED_TXT
                }
            }

            store.tasks.set('statusSearchText', tempStatusText)
        }

        //#endregion

        //#region RENDER METHODS

        renderHeader = () => {
            const numberOfAllNewTasks = store.tasks.numberOfAllNewTasks();
            const numberOfMyNewTasks = store.tasks.numberOfMyNewTasks();

            return (
                <div className="row align-items-center mb-3">
                    <div className="col ml-3">
                        <h6 className="element-inline">Tasks</h6>
                        <button
                            type="button"
                            onClick={this.cleanAllFilters.bind(this)}
                            className="btn btn-default button-clear-filters"
                        >Clear filters</button>
                    </div>
                    <div
                        className="col-auto"
                        data-toggle="buttons"
                        role="group"
                        aria-label="Tasks options"
                        id="meetings-cards">
                        <div className="btn-group pl-3 mr-3" role="tablist">
                            <a
                                className={`btn btn-outline-secondary ${this.state.filter ===
                                    TASK_ALL
                                    ? 'active'
                                    : ''}`}
                                data-toggle="tab"
                                role="tab"
                                onClick={() => this.setFilter(TASK_ALL)}>
                                All tasks
                                {numberOfAllNewTasks > 0 ? (
                                    <span className="badge badge-pill badge-notify animated swing">
                                        {numberOfAllNewTasks}
                                    </span>
                                ) : null}
                            </a>
                            {store.tasks.showMyTasksTab ? <a
                                className={`btn btn-outline-secondary ${this.state.filter ===
                                    TASK_MINE
                                    ? 'active'
                                    : ''}`}
                                data-toggle="tab"
                                role="tab"
                                onClick={() => this.setFilter(TASK_MINE)}>
                                My tasks
                                {numberOfMyNewTasks > 0 ? (
                                    <span className="badge badge-pill badge-notify animated swing">
                                        {numberOfMyNewTasks}
                                    </span>
                                ) : null}
                            </a> : null}
                        </div>
                    </div>
                </div>
            );
        };

        renderTaskRows = (tasks) => {
            let rows = [];
            tasks.forEach(

                function (task, index) {



                    rows.push(
                        <TaskCard
                            detail={task}
                            key={index}
                            instanceId={task.InstanceId}
                            onChangeStatus={this.onChangeStatus}
                        />,
                    );
                }.bind(this),
            );

            if (rows.length === 0)
            {
                rows.push(<TaskPlaceholder index="1" />)
            }

            return rows;
        };

        renderUserList = (users) => {
            let rows = [];
            users.forEach(
                function (user, index) {
                    rows.push(
                        <li key={index} name={"task-filter-owner" + index} className="hand-over owner-name" onClick={this.onChange}>{user.FirstName} {user.Surname}</li>,
                    );
                }.bind(this),
            );

            return rows;
        };

        renderCategoryList = (categories) => {
            let rows = [];

            categories.forEach(
                function (category, index) {
                    rows.push(
                        <li key={index} name={"task-filter-category" + index} className="hand-over category-name" onClick={this.onChange}>{category.CategoryName}</li>
                    );
                }.bind(this),
            );

            return rows;
        };

        render() {
            let tasks = store.tasks.filterTasksByCurrentHierarchyAndFilter(
                this.state.filter,
            );


            let users = store.tasks.usersFilteredByHierarchy;
            let categories = store.tasks.categoriesFilteredByHierarchy;
            return (
                <div style={{ marginBottom: '40px' }}>
                    {this.renderHeader()}
                    <div className="card">
                        <div className="tab-content" id="tasks-panel">
                            <div className="tab-pane active" id="all-tasks" role="tabpanel">
                                <div className="task-pad">
                                    <div className="task title-row">
                                        <div className="field-grp">
                                            <div>
                                                <div className="task-table-header" onClick={this.onClickTableHeaderColumn.bind(this, 0)}>
                                                    Title
                                                    {this.vars.titleFilterIcon ? <img alt="order" src={this.vars.currentOrderIcon} className="ml-1 sort-order-image" /> : null}
                                                </div>
                                                <div  className="task-table-header-filter">
                                                    <img alt="order" src={store.tasks.titleSearchText.length > 0 ? activeFilterIcon : filterIcon} name="task-filter-img1" className="btn-icon" onClick={this.onClickFilter.bind(this, 0)} />                                                     
                                                </div>  
                                                {this.vars.titleSearchBox ? 
                                                <ul className="task-dropdown-menu w-25" ref={node => this.node = node} name="task-filter-ul1">
                                                    <li className="p-lr-50 w-100" name="task-filter-li1">
                                                        <TitleInputBox
                                                            handleChange={this.onChange}
                                                            defaultValue={store.tasks.titleSearchText}
                                                            placeholderText="Title..."
                                                            />

                                                            <button
                                                                type="button"
                                                                onClick={this.cleanSearchBox.bind(this, 0)}
                                                                name="task-filter-button1"
                                                                className="btn btn-default">Clear
                                                        </button>
                                                        </li>
                                                    </ul> : null}
                                            </div>

                                            <div>Description</div>
                                        </div>

                                        <div className="field-grp">
                                            <div>
                                                <div className="task-table-header" onClick={this.onClickTableHeaderColumn.bind(this, 1)}>
                                                    Category
                                                    {this.vars.categoryFilterIcon ? <img alt="order" src={this.vars.currentOrderIcon} className="ml-1 sort-order-image" sort-order="up" /> : null}
                                                </div>
                                                <div  className="task-table-header-filter">
                                                    <img alt="filter" src={store.tasks.categorySearchText.length > 0 ? activeFilterIcon : filterIcon} name="task-filter-img2" className="btn-icon" onClick={this.onClickFilter.bind(this, 1)} />
                                                </div> 
                                                {this.vars.categorySearchBox ? 
                                                <ul className="task-dropdown-menu-category" ref={node => this.node = node} name="task-filter-ul2">
                                                        <li className="p-lr-50" name="task-filter-category1">
                                                            <CategoryInputBox
                                                                handleChange={this.onChange}
                                                                defaultValue={store.tasks.categorySearchText}
                                                                placeholderText="Category..."
                                                            />
                                                        </li>
                                                        {categories.length > 0 ?
                                                            <li className="divider" name="task-filter-category2"></li>
                                                            : null}
                                                        {this.renderCategoryList(categories)}
                                                        <li className="divider" name="task-filter-category5" onClick={this.onChange}></li>
                                                        <li className="li-padding" name="task-filter-category6">
                                                            <button
                                                                type="button"
                                                                onClick={this.cleanSearchBox.bind(this, 1)}
                                                                name="task-filter-button2"
                                                                className="btn btn-default">Clear
                                                            </button>
                                                        </li>
                                                    </ul> : null}
                                            </div>
                                            <div>
                                                <div className="task-table-header" onClick={this.onClickTableHeaderColumn.bind(this, 2)}>
                                                    Due date 
                                                    {this.vars.dueDateFilterIcon ? <img alt="order" src={this.vars.currentOrderIcon} className="ml-1 sort-order-image" sort-order="up" /> : null}
                                                </div>
                                                <div className="task-table-header-filter">
                                                    <img alt="filter" src={store.tasks.noDueDateFilter ? filterIcon : activeFilterIcon } name="task-filter-img3" className="btn-icon" onClick={this.onClickFilter.bind(this, 2)} />
                                                </div>
                                                {this.vars.dueDateSearchBox ?
                                                    <ul className="task-dropdown-menu-category" ref={node => this.node = node} name="task-filter-ul4">
                                                        <li className="p-lr-50 w-100 date-icon" name="task-filter-li4">
                                                            <DatePicker
                                                                name="task-start-date"
                                                                selected={store.tasks.dueStartDate}
                                                                selectsStart startDate={store.tasks.dueStartDate}
                                                                placeholderText="Start"
                                                                endDate={store.tasks.dueEndDate}
                                                                onChange={this.handleChangeStart} />
                                                            <img alt="calendar" src={calendarIcon} />
                                                        </li>
                                                        <li className="p-lr-50 w-100 date-icon" name="task-filter-li5">
                                                            <DatePicker
                                                                name="task-end-date"
                                                                selected={store.tasks.dueEndDate}
                                                                selectsEnd startDate={store.tasks.dueStartDate}
                                                                placeholderText="End"
                                                                endDate={store.tasks.dueEndDate}
                                                                onChange={this.handleChangeEnd} />
                                                            <img alt="calendar" src={calendarIcon} />
                                                        </li>
                                                        <li className="divider" name="task-filter-duedate1"></li>
                                                        <li className="li-padding" name="task-filter-owner6">
                                                            <button
                                                                type="button"
                                                                onClick={this.cleanSearchBox.bind(this, 2)}
                                                                name="task-filter-button4"
                                                                className="btn btn-default">Clear
                                                        </button>
                                                            <button
                                                                type="button"
                                                                onClick={this.getAllNoDueDateTasks.bind(this)}
                                                                name="task-filter-button5"
                                                                className="btn btn-default button-no-date">No date
                                                        </button>
                                                        </li>
                                                    </ul> : null}
                                            </div>
                                            <div>
                                                <div className="task-table-header hand-over" onClick={this.onClickTableHeaderColumn.bind(this, 3)}>
                                                    Owner
                                                    {this.vars.ownerFilterIcon ? <img alt="order" src={this.vars.currentOrderIcon} className="ml-1 sort-order-image" sort-order="up" /> : null}
                                                </div>
                                                <div  className="task-table-header-filter">
                                                    <img alt="filter" src={store.tasks.ownerSearchText.length > 0 ? activeFilterIcon : filterIcon} className="btn-icon" onClick={this.onClickFilter.bind(this, 3)} />
                                                </div> 
                                                {this.vars.ownerSearchBox ? 
                                                <ul className="task-dropdown-menu-owner pull-right" name="task-filter-ul3">
                                                    <li className="p-lr-50" name="task-filter-owner1">
                                                          <OwnerInputBox
                                                            handleChange=   {this.onChange}
                                                            defaultValue=   {store.tasks.ownerSearchText}
                                                            placeholderText="Owner..."
                                                          /> 
                                                    </li>
                                                    {users.length > 0 ?
                                                    <li className="divider" name="task-filter-owner2"></li>
                                                    : null}
                                                    {this.renderUserList(users)}
                                                    <li name="task-filter-owner5" className="divider"></li>
                                                    <li className="li-padding" name="task-filter-owner6">
                                                       <button 
                                                            type=       "button" 
                                                            onClick=    {this.cleanSearchBox.bind(this, 3)} 
                                                            name=       "task-filter-button3" 
                                                            className=  "btn btn-default">Clear
                                                        </button>
                                                        </li>
                                                    </ul> : null}
                                            </div>
                                            <div>
                                                <div className="task-table-header" onClick={this.onClickTableHeaderColumn.bind(this, 4)}>
                                                    Status
                                                    {this.vars.statusFilterIcon ? <img alt="order" src={this.vars.currentOrderIcon} className="ml-1 sort-order-image" sort-order="up" /> : null}
                                                </div>
                                                <div  className="task-table-header-filter">
                                                    <img alt="filter" src={store.tasks.statusSearchText.length > 0 ? activeFilterIcon : filterIcon} className="btn-icon" onClick={this.onClickFilter.bind(this, 4)} />
                                                </div>
                                                {this.vars.statusSearchBox ? 
                                                <ul className="task-dropdown-menu-status pull-right" name="task-filter-ul4">
                                                    <li name="task-filter-li4"><input type="checkbox"  checked={this.vars.statusNotCommenced} onChange={this.onChange} name="task-filter-ch1" className="mr-1 status-checkbox" /><span className="status-text" status="not-commenced">{TASK_NOT_COMMENCED_TXT}</span></li>
                                                    <li name="task-filter-li5"><input type="checkbox"  checked={this.vars.statusInProgress} onChange={this.onChange} name="task-filter-ch2" className="mr-1 status-checkbox" /><span className="status-text" status="in-progress">{TASK_IN_PROGRESS_TXT}</span></li>
                                                    <li name="task-filter-li6"><input type="checkbox"  checked={this.vars.statusComplete} onChange={this.onChange} name="task-filter-ch3" className="mr-1 status-checkbox" /><span className="status-text" status="complete">{TASK_COMPLETE_TXT}</span></li>
                                                    <li name="task-filter-li8" className="divider"></li>
                                                    <li name="task-filter-li9" className="li-padding">
                                                        <button 
                                                                type=       "button" 
                                                                onClick=    {this.cleanSearchBox.bind(this, 4)} 
                                                                name=       "task-filter-button4" 
                                                                className=  "btn btn-default ml-11">Clear
                                                        </button>
                                                        </li>
                                                    </ul> : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ErrorBoundary>
                            {this.renderTaskRows(tasks)}
                        </ErrorBoundary>
                    </div>
                </div>
            );
        };
    });
//#endregion

export default TaskPanel;


// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Task/TaskPanel.js